export const callStatusMatching = (callStatusList, status) => {
  return callStatusList?.find((item) => item.value === status)?.label;
};
